import script from "./leftPie.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie.vue?vue&type=script&setup=true&lang=js"

import "./leftPie.vue?vue&type=style&index=0&id=1a7bf329&scoped=true&lang=css"
script.__scopeId = "data-v-1a7bf329"

export default script